module.exports = __webpack_public_path__ + "static/ripleys-game-eed6353653826272b741aeff97eb4e16.jpg";